var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { RefetchIntervals } from '#constants';
import { useLucidSdk } from '#context';
import { HealthCheckKeyFactory } from '../../query-key-factories';
export const useHealthCheck = ({ enabled = true, retry = false, } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const query = useQuery({
        queryKey: HealthCheckKeyFactory.healthCheck(),
        queryFn: () => lucidSdk
            .publicClient()
            .checkServiceStatus()
            // query functions cannot return `undefined` or `void`
            .then(() => true),
        networkMode: 'always',
        refetchInterval: RefetchIntervals.m,
        enabled,
        retry,
        // Do not under any circumstances overwrite the `gcTime` or `throwOnError` in local use of this hook
        // Cache for this hook must be reset immediately after the hook is out of use, throwing of errors here shouldn't happen also
        gcTime: 0,
        throwOnError: false,
    });
    return { query };
};
_react_refresh_temp_1(useHealthCheck, "H/nX1eMsJ0bsH20/D0j9QAs2SDk=", false, () => [useLucidSdk, useQuery]);
